<template>
  <div>
    <!-- 时段选择区域 -->
    <div v-show="!isPreview" class="duration">
      <ul class="header">
        <li class="info">星期\时间</li>
        <li class="time">
          <div class="num">00:00 - 12:00</div>
          <ul class="detail clearfix">
            <li
              v-for="(item ,index) in new Array(12)"
              :key="index"
              class="digital"
            >{{ index }}</li>
          </ul>
        </li>
        <li class="time">
          <div class="num pm">12:00 - 24:00</div>
          <ul class="detail">
            <li
              v-for="(item ,index) in new Array(12)"
              :key="index"
              class="digital"
            >{{ index+12 }}</li>
          </ul>
        </li>
      </ul>
      <div class="content">
        <ul class="week">
          <li v-for="(item ,index) in timeWeek" :key="index" class="day">星期{{ timeWeek[index] }}</li>
        </ul>
        <div :id="boxzone" :class="{ 'hour': isHour }" class="time-boxzone" @mousedown="down($event)" @mouseleave="mouseleaveFn">
          <el-tooltip
            v-for="(item ,index) in liArr"
            :key="index"
            class="item"
            effect="light"
            :open-delay="800"
            placement="top"
            :disabled="show_top_tips"
          >
            <div slot="content">{{ `星期${time_arr.week} ${time_arr.StartTime}-${time_arr.EndTime}` }}</div>
            <div
              ref="show"
              class="box"
              @mouseenter="showTime(index)"
              @click="changeColor($event,index)"
            />
          </el-tooltip>
        </div>
      </div>
    </div>
    <!-- 时段展示区域 -->
    <div class="timeshow">
      <p v-if="week1.length!==0">
        星期一:
        <span
          v-for="(item, index) in week1"
          :key="index"
          :value="item.url"
        >{{ `${item.StartTime}~${item.EndTime}` }}</span>
      </p>
      <p v-if="week2.length!==0">
        星期二:
        <span
          v-for="(item, index) in week2"
          :key="index"
          :value="item.url"
        >{{ `${item.StartTime}~${item.EndTime}` }}</span>
      </p>
      <p v-if="week3.length!==0">
        星期三:
        <span
          v-for="(item, index) in week3"
          :key="index"
          :value="item.url"
        >{{ `${item.StartTime}~${item.EndTime}` }}</span>
      </p>
      <p v-if="week4.length!==0">
        星期四:
        <span
          v-for="(item, index) in week4"
          :key="index"
          :value="item.url"
        >{{ `${item.StartTime}~${item.EndTime}` }}</span>
      </p>
      <p v-if="week5.length!==0">
        星期五:
        <span
          v-for="(item, index) in week5"
          :key="index"
          :value="item.url"
        >{{ `${item.StartTime}~${item.EndTime}` }}</span>
      </p>
      <p v-if="week6.length!==0">
        星期六:
        <span
          v-for="(item, index) in week6"
          :key="index"
          :value="item.url"
        >{{ `${item.StartTime}~${item.EndTime}` }}</span>
      </p>
      <p v-if="week7.length!==0">
        星期日:
        <span
          v-for="(item, index) in week7"
          :key="index"
          :value="item.url"
        >{{ `${item.StartTime}~${item.EndTime}` }}</span>
      </p>
    </div>
    <!-- 提示和清除区域 -->
    <div v-show="!isPreview" class="duration-tipline">
      <div class="flex justify-between align-center" style="width: 130px;">
        <div class="status-box" :style="{ 'background-color': themeColor, 'border': 'none' }" />
        <span>已选</span>
        <div class="status-box" />
        <span>未选</span>
      </div>
      <div>
        <el-button icon="el-icon-delete" size="mini" @click="clearTime">清除</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScheduleTime',
  props: {
    preele: {
      type: String,
      default: () => {
        return 'addplan_main';
      },
    },
    /** 非响应式值 - time与value不可同时使用 */
    time: {
      type: String,
      default: null,
    },
    /** 响应式值 - time与value不可同时使用  */
    value: {
      type: Object,
      default: () => ({ schedule_time_content: null }),
    },
    /** 主题色 - 颜色的格式必须为 标准且规范的RGB格式 或者 颜色关键字（red、blue等） */
    themeColor: {
      type: String,
      default: 'rgb(64, 158, 255)',
    },
    /** 是否展示为预览模式 - 仅展示【时段展示区域】 */
    isPreview: {
      type: Boolean,
      default: false,
    },
    /** 是否以每小时为最小时间单位 - true：每小时为最小单位，false：每半小时为最小单位 */
    isHour: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      last_x: 0,
      last_y: 0,
      show_top_tips: false,
      // 时间段星期数组
      timeWeek: ['一', '二', '三', '四', '五', '六', '日'],
      week: null,
      StartTime: null,
      EndTime: null,
      week1: [],
      week2: [],
      week3: [],
      week4: [],
      week5: [],
      week6: [],
      week7: [],
      CheckedTime: {
        week: null,
        StartTime: null,
        EndTime: null,
      },
      // 显示时间段
      time_arr: {
        week: null,
        StartTime: null,
        EndTime: null,
        selectBoxDashed: null,
        startX: null,
        startY: null,
        initx: null,
        scrollX: null,
        scrollY: null,
        inity: null,
      },
      liArr: [],
      schedule_time: '',
      // 时间选择区域dom元素id
      boxzone: 'boxzone',
    };
  },
  watch: {
    // value值改变时触发渲染
    value: {
      deep: true,
      handler() {
        this.renderTime(this.value.schedule_time_content);
        this.isCheckedList();
      },
    },
  },
  // 生命周期-创建
  created() {
    this.liArr = new Array(this.isHour ? 168 : 336);
  },
  mounted() {
    // 确保每个时间组件id值唯一，在创建多个时间组件时，避免id相同，dom获取元素不准确导致时间组件失效问题
    this.boxzone += `-${this.randomUUID()}`;
    // 渲染时间 - 保留 兼容旧逻辑
    this.renderTime(this.time);
    if (this.value?.schedule_time_content) {
      this.renderTime(this.value.schedule_time_content);
    }
    // 时间段
    this.isCheckedList();
  },
  methods: {
    // 清除时间冒泡
    clearBubble(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      } else {
        e.cancelBubble = true;
      }
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
    },

    // 鼠标按下
    down(e) {
      // 不显示toptips
      this.show_top_tips = true;
      //  创建选框节点
      this.time_arr.selectBoxDashed = document.createElement('div');
      this.time_arr.selectBoxDashed.className = 'select-box-dashed';

      document.body.appendChild(this.time_arr.selectBoxDashed);
      this.time_arr.scrollX =
        document.documentElement.scrollLeft || document.body.scrollLeft;
      this.time_arr.scrollY =
        document.documentElement.scrollTop || document.body.scrollTop;
      //  设置选框的初始位置
      this.time_arr.startX =
        e.x + this.time_arr.scrollX || e.clientX + this.time_arr.scrollX;
      this.time_arr.startY =
        e.y + this.time_arr.scrollY || e.clientY + this.time_arr.scrollY;
      this.time_arr.selectBoxDashed.style.cssText = `left:${this.time_arr.startX}px; top:${this.time_arr.startY}px; border: 1px dashed ${this.themeColor}`;
      //  清除事件冒泡、捕获
      this.clearBubble(e);
      document
        .getElementById(this.boxzone)
        .addEventListener('mousemove', this.mousemovefn);
      document
        .getElementById(this.boxzone)
        .addEventListener('mouseup', this.mouseUpfn);
    },

    // 离开事件
    mouseleaveFn(e) {
      if (e.relatedTarget?.className === 'select-box-dashed') {
        return;
      }
      this.show_top_tips = false;
      if (document.getElementsByClassName('select-box-dashed')[0]) {
        document.getElementsByClassName('select-box-dashed')[0].remove();
        document
          .getElementById(this.boxzone)
          .removeEventListener('mousemove', this.mousemovefn);
        document
          .getElementById(this.boxzone)
          .removeEventListener('mouseup', this.mouseUpfn);
      }
    },

    // 鼠标移动
    mousemovefn(e) {
      //  设置选框可见
      this.time_arr.selectBoxDashed.style.display = 'block';
      //  根据鼠标移动，设置选框的位置、宽高
      this.time_arr.initx =
        e.x + this.time_arr.scrollX || e.clientX + this.time_arr.scrollX;
      this.time_arr.inity =
        e.y + this.time_arr.scrollY || e.clientY + this.time_arr.scrollY;
      //  暂存选框的位置及宽高，用于将 select-item 选中
      this.left = Math.min(this.time_arr.initx, this.time_arr.startX);
      this.top = Math.min(this.time_arr.inity, this.time_arr.startY);
      this.width = Math.abs(this.time_arr.initx - this.time_arr.startX);
      this.height = Math.abs(this.time_arr.inity - this.time_arr.startY);
      this.time_arr.selectBoxDashed.style.left = `${this.left + 1}px`;
      this.time_arr.selectBoxDashed.style.top = `${this.top + 1}px`;
      this.time_arr.selectBoxDashed.style.width = `${this.width - 1}px`;
      this.time_arr.selectBoxDashed.style.height = `${this.height - 1}px`;

      const fileDivs = document.getElementsByClassName('box');
      for (let i = 0; i < fileDivs.length; i++) {
        const itemX_pos =
          fileDivs[i].offsetWidth + this.getElementLeft(fileDivs[i]);
        const itemY_pos =
          fileDivs[i].offsetHeight + this.getElementTop(fileDivs[i]);
        const condition1 = itemX_pos > this.left;
        const condition2 = itemY_pos > this.top;
        const condition3 =
          this.getElementLeft(fileDivs[i]) < this.left + this.width;
        const condition4 =
          this.getElementTop(fileDivs[i]) < this.top + this.height;
        if (condition1 && condition2 && condition3 && condition4) {
          fileDivs[i].classList.add('temp-selected');
        } else {
          fileDivs[i].classList.remove('temp-selected');
        }
      }
      this.clearBubble(e);
    },

    // 鼠标抬起
    mouseUpfn(e) {
      this.show_top_tips = false;
      document
        .getElementById(this.boxzone)
        .removeEventListener('mousemove', this.mousemovefn);
      const selectDom = document.getElementsByClassName('temp-selected');
      [].slice.call(selectDom).forEach((item) => {
        if (item.style) {
          if (item.style.backgroundColor === this.themeColor) {
            item.style.backgroundColor = '';
          } else {
            item.style.backgroundColor = this.themeColor;
          }
          item.classList.remove('temp-selected');
        }
      });
      if (this.time_arr.selectBoxDashed) {
        try {
          this.time_arr.selectBoxDashed.parentNode.removeChild(
            this.time_arr.selectBoxDashed
          );
        } catch (err) {
          console.log(err);
        }
      }
      // 判断哪些被选中
      this.isCheckedList();
      // 更新选中值
      this.value.schedule_time_content = this.addTime();
      this.clearBubble(e);
    },

    isCheckedList() {
      var arr = [];
      const length = this.isHour ? 168 : 336;
      for (var i = 0; i < length; i++) {
        if (this.$refs.show[i].style) {
          if (this.$refs.show[i].style.backgroundColor === this.themeColor) {
            arr.push(i);
          }
        }
      }

      // 先清空每周的数据
      for (var k = 1; k < 8; k++) {
        this[`week${k}`] = [];
      }
      arr.forEach((item) => {
        this.ChangeHourMinutestr(item * (this.isHour ? 60 : 30));
        this.CheckedTime.week = this.week;
        this.CheckedTime.StartTime = this.StartTime;
        this.CheckedTime.EndTime = this.EndTime;
        for (var i = 0; i < this.timeWeek.length; i++) {
          if (this.CheckedTime.week === this.timeWeek[i]) {
            this.addTimeArr(
              i + 1,
              this.CheckedTime.StartTime,
              this.CheckedTime.EndTime
            );
          }
        }
      });
      // 合并时间段
      this.menerArr();
    },

    menerArr() {
      for (var i = 1; i < 8; i++) {
        this[`week${i}`] = this.checkData(this[`week${i}`]);
      }
    },

    // 把时间段添加到对应星期的数组中
    addTimeArr(week, start, end) {
      const time = {
        EndTime: end,
        StartTime: start,
      };
      this[`week${week}`].push(time);
      this[`week${week}`] = this.clearRepetition(this[`week${week}`]);
    },

    // 数组对象去重
    clearRepetition(arr) {
      const obj = {};
      const peon = arr.reduce((cur, next) => {
        obj[next.StartTime]
          ? ''
          : (obj[next.StartTime] = true && cur.push(next));
        return cur;
      }, []); // 设置cur默认类型为数组，并且初始值为空的数组
      return peon;
    },

    checkData(arr) {
      const common = [];
      let continuity_start = '';
      let continuity_end = '';
      let last_start = '';
      let last_end = '';
      arr.forEach((item, index) => {
        // 当数组为多个时间段时
        if (arr.length > 1) {
          // 当检测自己跟下一个是连续时
          if (arr[index + 1]) {
            if (item.EndTime === arr[index + 1].StartTime) {
              if (last_end !== item.StartTime) {
                continuity_start = item.StartTime;
              }
            } else {
              if (last_end !== item.StartTime) {
                continuity_start = item.StartTime;
              }
              continuity_end = item.EndTime;
              const _timestep = {
                StartTime: continuity_start,
                EndTime: continuity_end,
              };
              common.push(_timestep);
            }
            last_start = item.StartTime;
            typeof last_start;
            last_end = item.EndTime;
          } else {
            if (last_end !== item.StartTime) {
              continuity_start = item.StartTime;
            }
            const _timestep = {
              StartTime: continuity_start,
              EndTime: item.EndTime,
            };
            common.push(_timestep);
          }
        }

        // 当数组只有一个单一时间段时
        if (arr.length === 1) {
          const _timestep = {
            StartTime: item.StartTime,
            EndTime: item.EndTime,
          };
          common.push(_timestep);
        }
      });
      return common;
    },

    // 时间转秒
    getTimesept(time) {
      const hour = time.split(':')[0];
      const min = time.split(':')[1];
      return Number(hour * 3600) + Number(min * 60);
    },

    // 获取网页元素的绝对位置
    getElementLeft(ele) {
      var actualLeft = ele.offsetLeft;
      var current = ele.offsetParent;
      var elementScrollLeft = document.getElementsByClassName(this.preele)[0]
        .scrollLeft;
      while (current !== null) {
        actualLeft += current.offsetLeft + current.clientLeft;
        current = current.offsetParent;
      }
      return actualLeft - elementScrollLeft;
    },

    getElementTop(ele) {
      var actualTop = ele.offsetTop;
      var current = ele.offsetParent;
      var elementScrollTop = document.getElementsByClassName(this.preele)[0]
        .scrollTop;
      while (current !== null) {
        actualTop += current.offsetTop + current.clientTop;
        current = current.offsetParent;
      }

      return actualTop - elementScrollTop;
    },

    // 单点选择
    changeColor(e, i) {
      document
        .getElementById(this.boxzone)
        .removeEventListener('mousemup', this.mouseUpfn);
      this.clearBubble(e);
      if (this.$refs.show[i].style) {
        if (this.$refs.show[i].style.backgroundColor === '') {
          this.$refs.show[i].style.backgroundColor = this.themeColor;
        } else {
          this.$refs.show[i].style.backgroundColor = '';
        }
      }
      this.isCheckedList();
      // 更新选中值
      this.value.schedule_time_content = this.addTime();
    },

    // 清除所有选择
    clearTime() {
      const length = this.isHour ? 168 : 336;
      for (let i = 0; i < length; i++) {
        this.$refs.show[i].style.backgroundColor = '';
      }
      this.schedule_time = '';
      for (var i = 1; i < 8; i++) {
        this[`week${i}`] = [];
      }
      // 更新选中值
      this.value.schedule_time_content = this.addTime();
    },

    // 鼠标移上去显示时间段
    showTime(i) {
      this.ChangeHourMinutestr(i * (this.isHour ? 60 : 30));
      this.time_arr.week = this.week;
      this.time_arr.StartTime = this.StartTime;
      this.time_arr.EndTime = this.EndTime;
    },

    // 处理选择事件段
    addTime() {
      this.schedule_time = '';
      this.$refs.show.forEach((item, index) => {
        if (item.style.backgroundColor === '') {
          this.schedule_time += '0';
        } else {
          this.schedule_time += '1';
        }
      });
      return this.schedule_time;
    },

    // 编辑状态下显示
    renderTime(time) {
      if (time) {
        for (let i = 0; i < time.length; i++) {
          if (time[i] === '0') {
            this.$refs.show[i].style.backgroundColor = '';
          } else {
            this.$refs.show[i].style.backgroundColor = this.themeColor;
          }
        }
      }
    },

    // 把分钟转化成小时
    ChangeHourMinutestr(str) {
      if (str !== '0' && str !== '' && str !== null) {
        this.week = Math.ceil(str / 1439);
        if (this.week === 0 || this.week === 1) {
          this.week = this.timeWeek[0];
        } else {
          this.week = this.timeWeek[this.week - 1];
        }
        str = str - 1440 * Math.floor(str / 1440);
        this.StartTime = this.returnTime(str);
        this.EndTime = this.returnTime(str + (this.isHour ? 60 : 30));
      } else {
        return '';
      }
    },

    returnTime(str) {
      return (
        (Math.floor(str / 60).toString().length < 2
          ? '0' + Math.floor(str / 60).toString()
          : Math.floor(str / 60).toString()) +
        ':' +
        ((str % 60).toString().length < 2
          ? '0' + (str % 60).toString()
          : (str % 60).toString())
      );
    },

    /**
     * 生成唯一字符串
     * @param {number} len 指定生成字串的长度
     * @param {number} radix 指定生成字串的基数长度
     * @returns {string}
     */
    randomUUID(len = 32, radix = 16) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
      const uuid = [];
      let i;
      radix = radix || chars.length;
      if (len) {
        for (i = 0; i < len; i++) {
          uuid[i] = chars[0 | (Math.random() * radix)];
        }
      } else {
        let r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16);
            uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
          }
        }
      }
      return uuid.join('');
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.duration {
  width: 662px;
  border: 1px solid rgba(217, 218, 219, 0.8);
  font-size: inherit;
  margin-left: 0;
  .header {
    display: flex;
    height: 52px;
    .info {
      flex: 1;
      line-height: 52px;
      width: 80px;
      border-right: 1px solid rgba(217, 218, 219, 0.8);
      color: #888;
      text-align: center;
    }
    .time {
      display: flex;
      flex-direction: column;
      width: 290px;
      .num {
        height: 35px;
        line-height: 35px;
        width: 100%;
        border-bottom: 1px solid rgba(217, 218, 219, 0.8);
        text-align: center;
        box-sizing: border-box;
      }
      .pm {
        border-left: 1px solid rgba(217, 218, 219, 0.8);
      }
      .detail {
        display: flex;
        width: 290px;
        .digital {
          flex: 1;
          height: 16px;
          line-height: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          border-right: none;
          text-align: center;
        }
      }
    }
  }
  .content {
    display: flex;
    .week {
      flex: 1;
      .day {
        border-top: 1px solid rgba(217, 218, 219, 0.8);
        border-right: 1px solid rgba(217, 218, 219, 0.8);
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #888;
      }
    }
    .time-boxzone {
      width: 580px;
      height: 100%;
      overflow: hidden;
      display: grid;
      grid-template-rows: repeat(7, 1fr);
      grid-template-columns: repeat(48, 1fr);
      .box {
        height: 35px;
        background: #fff;
        border-right: 1px solid rgba(217, 218, 219, 0.8);
        border-top: 1px solid rgba(217, 218, 219, 0.8);
        &:nth-child(48n) {
          border-right: none;
        }
      }
      &.hour {
        grid-template-columns: repeat(24, 1fr);
        .box {
          &:nth-child(24n) {
            border-right: none;
          }
        }
      }
    }
  }
}
ul {
  list-style: none;
}
.el-a {
  color: blue;
}
li,
p,
span,
ul {
  padding: 0;
  margin: 0;
}
.clearfix {
  clear: both;
}
.duration .time-boxzone .box:not(.active):not(.choosed):nth-of-type(odd) {
  background: #f8f9fa;
}
.el-step__head:hover,
.el-step__title:hover {
  color: palevioletred;
  border-color: palevioletred;
  cursor: pointer;
}
.title_input .el-input__inner {
  width: 45%;
  margin-bottom: 1%;
}
.duration-tipline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  width: 100%;
  max-width: 662px;
  color: #606266;
  .status-box {
    width: 32px;
    height: 16px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
  }
}
.el-radio__label img {
  display: block;
  width: 100%;
}
.convert_input .el-input {
  width: 30%;
}
.static_title_box {
  margin-top: 5px;
  .el-input {
    width: 300px;
  }
}
.timeshow {
  border: 1px solid #ebebeb;
  width: 662px;
  overflow: hidden;
  margin-top: 10px;
}
.timeshow span {
  color: #606266;
  margin-left: 10px;
}
.timeshow p {
  margin-top: 6px;
  width: 100%;
  color: #606266;
  overflow: auto;
  white-space: nowrap;
  padding: 0 10px;
}
</style>
<style>
.select-box-dashed {
  position: absolute;
  display: none;
  width: 0px;
  height: 0px;
  padding: 0px;
  margin: 0px;
  border: 1px dashed rgb(64, 158, 255);
  background-color: #fff;
  opacity: 0.5;
  filter: alpha(opacity=50);
  font-size: 0px;
  z-index: 99999;
}
.addplan_main {
  padding: 10px;
  border-radius: 5px;
  background: #eff2f6;
  width: 60%;
  overflow: auto;
  margin-top: 0%;
  margin-left: 0%;
}
</style>

